import { useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// ✅ Styled Option Card (same style as your reference)
const OptionCard = styled(Paper)(({ theme, selected }) => ({
  padding: theme.spacing(4),
  borderRadius: "20px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.08)",
  cursor: "pointer",
  textAlign: "center",
  transition: "transform 0.25s ease, box-shadow 0.25s ease",
  minHeight: "160px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",

  "&:hover": {
    transform: "translateY(-3px)",
    boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.12)",
  },

  ...(selected && {
    border: "2px solid #30B0C7",
  }),
}));

const StepFour = ({ onNext }) => {
  const options = [
    { label: "Employment", icon: "./Counselling/fullIcon.png" },
    { label: "Higher studies", icon: "./Counselling/partialIcon.png" },
    {
      label: "Business/Entrepreneurship",
      icon: "./Counselling/guidanceIcon.png",
    },
    { label: "Job Switch", icon: "./Counselling/fullIcon.png" },
    {
      label: "Business/Entrepreneurship switch",
      icon: "./Counselling/partialIcon.png",
    },
    { label: "Other", icon: "./Counselling/guidanceIcon.png" },
  ];

  const [selected, setSelected] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [otherValue, setOtherValue] = useState("");

  const handleSelect = (item) => {
    if (item === "Other") {
      setOpenDialog(true);
    } else {
      setSelected(item);
    }
  };

  const handleConfirmOther = () => {
    if (!otherValue.trim()) return;
    setSelected(otherValue.trim());
    setOpenDialog(false);
  };

  const handleNextClick = () => {
    if (selected) onNext({ lookingFor: selected });
  };

  return (
    <Box>
      <Typography
        sx={{ textAlign: "center", fontFamily: "Aclonica", py: 2 }}
        variant="h4"
        fontWeight={600}
        mb={3}
      >
        What are you looking for?
      </Typography>

      <Grid container spacing={2} sx={{ alignItems: "stretch" }}>
        {options.map(({ label, icon }) => (
          <Grid item xs={12} sm={6} md={4} key={label}>
            <OptionCard
              selected={selected === label}
              onClick={() => handleSelect(label)}
            >
              <img
                src={icon}
                alt={label}
                style={{
                  width: "60px",
                  height: "60px",
                  objectFit: "contain",
                  marginBottom: "12px",
                }}
              />
              <Typography fontSize="1rem" fontWeight={600}>
                {label}
              </Typography>
            </OptionCard>
          </Grid>
        ))}
      </Grid>

      {/* ✅ Next Button */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button
          variant="contained"
          disabled={!selected}
          onClick={handleNextClick}
          sx={{
            mt: 4,
            backgroundColor: "#30B0C7",
            borderRadius: "100px",
            textTransform: "none",
            fontWeight: 600,
            "&:hover": { backgroundColor: "#2799AD" },
            width: "200px",
            p: 1,
            fontSize: "20px",
          }}
        >
          Next
        </Button>
      </div>

      {/* ✅ Dialog for "Other" */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)}>
        <DialogTitle>Enter your preference</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            autoFocus
            margin="dense"
            label="Your Input"
            value={otherValue}
            onChange={(e) => setOtherValue(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleConfirmOther}>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default StepFour;
